/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
// Need to use the React-specific entry point to import createApi
import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';

import {calculateHeaderList} from './commonUtil';
import {AEMContentType, HeaderLink, SessionDataType} from './types';
// Define a service using a base URL and expected endpoints
export const aemContentApi = createApi({
  reducerPath: 'aemContentApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env['NEXT_PUBLIC_AEM_DOMAIN_URL']
  }),
  endpoints: (builder) => ({
    getAemContent: builder.query<AEMContentType, string>({
      query: (contentEndpoint) => contentEndpoint,
      transformResponse: (responseData: {
        data?: {UtahHomePageContent?: {items?: {data?: {utahHomePageContent?: AEMContentType}}[]}};
      }): AEMContentType => {
        return responseData?.data?.UtahHomePageContent?.items?.[0]?.data?.utahHomePageContent || ({} as AEMContentType);
      }
    })
  })
});

export const sessionApi = createApi({
  reducerPath: 'sessionApi',
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    getSessionData: builder.query<SessionDataType, string>({
      query: (sessionEndpoint) => sessionEndpoint,
      transformResponse: (responseData): SessionDataType => {
        sessionStorage.setItem('session', JSON.stringify(responseData));
        sessionStorage.setItem('Session-id', (responseData as SessionDataType).id);
        return responseData as SessionDataType;
      }
    })
  })
});

export const accountDetailsApi = createApi({
  reducerPath: 'accountDetailsApi',
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    getAccountDetails: builder.query<any, string>({
      query: (sessionEndpoint) => sessionEndpoint,
      transformResponse: (responseData): any => {
        const selectedAccount = (
          responseData as {isSelected: boolean; accountIdentifier: string; accountDisplayName: string}[]
        )?.find((account) => account.isSelected);
        return {
          accountId: selectedAccount?.accountIdentifier,
          accountName: selectedAccount?.accountDisplayName
        };
      }
    })
  })
});

export const lookupDataApi = createApi({
  reducerPath: 'lookupDataApi',
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    getLookupDataApi: builder.query<any, {lookupPath: string; headerList: HeaderLink[]; payeeId: string}>({
      query: (args) => args.lookupPath,
      transformResponse: (responseData: any, _, arg) => {
        const response = (responseData as {result?: unknown})?.result;
        if (response) {
          return calculateHeaderList(response, arg.headerList, arg.payeeId);
        }
        return null;
      },
      transformErrorResponse: (error: any, _, arg) => {
        return {
          error,
          headerData: arg.headerList.filter((item) => item.defaultHeader)
        };
      }
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {useGetAemContentQuery} = aemContentApi;
export const {useGetAccountDetailsQuery} = accountDetailsApi;
export const {useLazyGetSessionDataQuery} = sessionApi;
export const {useLazyGetLookupDataApiQuery} = lookupDataApi;
